// material-ui

// project import
import MainLayout from 'layout/MainLayout';
import CloudLayout from 'layout/CloudLayout';
import AuthGuard from 'layout/AuthLayout/guard';
import LogoutDialog from 'sections/_parts/LogoutDialog';

type Props = {
  variant: string;
};

const AuthLayout = (props: Props) => {
  const { variant } = props;
  return (
    <AuthGuard>
      <>
        {variant === 'cloud' ? <CloudLayout /> : <MainLayout />}
        <LogoutDialog />
      </>
    </AuthGuard>
  );
};

export default AuthLayout;
